import React from 'react';
import Form from '../form/Form';

class Card extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: null
    }
  }

  render() {
    const props = JSON.parse(JSON.stringify(this.props));
    const { id, content } = props;
    return (
      <div className='card'>
        <div className='card-header' id={id}>
          <a data-toggle='collapse'
            data-target={'#collapse-' + id}
            aria-expanded='false'
            aria-controls={'collapse-' + id}
            href='/'>{content.form_alias}</a>
        </div>
        <div id={'collapse-' + id} className='collapse' aria-labelledby={id} data-parent='#accordion'>
          <div className='card-body'>
            <Form 
              formTitle={content.form_alias}
              content={content}
              isCalculationForm={false}
              size={this.props.size}
              show={this.props.show}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Card
